import { createContext, useCallback, useContext, useEffect, useMemo, useState, lazy, Suspense } from 'react';
import { Text } from 'styles';

const AlertContext = createContext({
  alert: () => {},
  toggleAlert: () => {},
});

const Modal = lazy(() => import('components/dialogs/Modal'));

export function AlertContextProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({
    type: 'primary', // primary, delete
    message: '',
    close: () => {},
    confirm: undefined,
    cancel: undefined,
    del: undefined,
    onClose: undefined,
  });

  const alert = useCallback((alertData) => {
    toggleAlert(true);
    const closeAlert = () => toggleAlert(false);
    const type = alertData.type || 'primary';

    setData({
      ...alertData,
      close: type === 'primary' ? alertData.close || closeAlert : undefined,
      cancel: type === 'delete' ? alertData.cancel || closeAlert : undefined,
      confirm: alertData.confirm,
      del: alertData.del,
    });
  }, []);

  const toggleAlert = useCallback((value) => {
    setOpen((prevState) => value ?? !prevState);
  }, []);

  const value = useMemo(() => {
    const val = {
      alert,
      toggleAlert,
    };

    return val;
  }, [alert, toggleAlert]);

  useEffect(() => {
    if (!open) {
      if (data.onClose && typeof data.onClose === 'function') data.onClose();

      setData({ message: '', close: undefined, confirm: undefined, del: undefined, cancel: undefined, onClose: undefined });
    }
  }, [open]);

  return (
    <AlertContext.Provider value={value}>
      {children}
      <Suspense>
        <Modal open={open} setOpen={() => setOpen(false)} close={data.close} confirm={data.confirm} cancel={data.cancel} del={data.del}>
          <Text $color="strong">{data.message}</Text>
        </Modal>
      </Suspense>
    </AlertContext.Provider>
  );
}

export function useAlertContext() {
  const context = useContext(AlertContext);
  return context;
}

export default useAlertContext;
